// extracted by mini-css-extract-plugin
export default {"container":"XfcIEMWxFu","checkbox-container":"QLfQNFjRgf","checkboxContainer":"QLfQNFjRgf","checkbox":"Tw9ggRtAEu","input":"ACBUyOz9ZW"};